// extracted by mini-css-extract-plugin
export default {"deleteOverlay":"A4-z","cancel":"B4-z","disabled":"C4-z","delete":"D4-z"};